{
  "cloud": {
    "tagline": "Des ressources cloud adaptées à vos applications.",
    "description": "Déployez et gérez vos applications sur une infrastructure opérée en France.",
    "items": {
      "standard": {
        "title": "VPS Standard",
        "description": "Basé sur un processeur Intel en LXC, KVM & Windows"
      },
      "performance": {
        "title": "VPS Performance",
        "description": "Basé sur un processeur AMD Ryzen en LXC, KVM & Windows"
      },
      "plesk": {
        "title": "Hébergement Plesk",
        "description": "Espace web managé avec panneau Plesk"
      },
      "pleskDedicated": {
        "title": "Plesk sur VPS",
        "description": "VPS avec Plesk préinstallé, licence Web Admin incluse"
      }
    },
    "highlight": {
      "label": "Anti-DDoS · inclus",
      "metric": "L3/L4",
      "caption": "Mitigation permanente"
    },
    "note": {
      "text": "Protection incluse sur tous nos VPS et serveurs, sans surcoût ni configuration.",
      "detail": "eBPF/XDP · Détection comportementale · Gaming"
    },
    "banner": {
      "title": "Louez votre serveur dédié à partir de 59,99 €",
      "caption": "Intel & AMD Ryzen"
    }
  },
  "infra": {
    "tagline": "Connectez vos sites et hébergez vos équipements à Paris.",
    "description": "Colocation, tunnels IP et protection réseau pour relier votre infrastructure.",
    "items": {
      "datacenter": {
        "title": "Datacenter",
        "description": "Colocation de 1U au rack complet"
      },
      "tunnels": {
        "title": "Tunnels IP",
        "description": "Interconnexions IP et tunnels réseau configurés selon vos besoins"
      },
      "ddos": {
        "title": "Protection DDoS",
        "description": "Filtrage permanent des attaques réseau L3/L4"
      }
    },
    "highlight": {
      "label": "Rack complet",
      "metric": "42U",
      "caption": "Baie 42U · 10 kW · 20 Gbps"
    },
    "note": {
      "text": "Onduleurs et refroidissement : redondance N+1.",
      "detail": "Alimentation secourue · Accès contrôlé"
    },
    "banner": {
      "title": "Equinix PA6",
      "caption": "Onduleurs et refroidissement : redondance N+1."
    }
  },
  "web": {
    "tagline": "Votre présence en ligne commence ici.",
    "description": "Domaines, hébergement, certificats et DNS pour créer et sécuriser vos sites web.",
    "items": {
      "domains": {
        "title": "Noms de domaine",
        "description": "Plus de 500 extensions disponibles, transfert facile"
      },
      "plesk": {
        "title": "Hébergement Plesk",
        "description": "Espace web managé avec panneau Plesk"
      },
      "ssl": {
        "title": "Certificats SSL",
        "description": "Let's Encrypt inclus avec l’hébergement Plesk"
      }
    },
    "highlight": {
      "label": "Nom de domaine",
      "metric": ".fr",
      "caption": "Enregistrement et transfert"
    },
    "note": {
      "text": "Transférez vos domaines chez nous et bénéficiez d’un an d’extension offert.",
      "detail": "WHOIS gratuit · DNS anycast · Renouvellement auto"
    },
    "banner": {
      "title": "Recherchez votre nom de domaine",
      "caption": ".fr · .com · .io · .dev · .eu et 500+ extensions"
    }
  },
  "ent": {
    "tagline": "Solutions professionnelles pour accélérer votre activité.",
    "description": "Licences, connectivité fibre et téléphonie pour les entreprises de toute taille.",
    "items": {
      "microsoft": {
        "title": "Microsoft 365",
        "description": "Suite Office et messagerie professionnelle"
      },
      "google": {
        "title": "Google Workspace",
        "description": "Outils collaboratifs et Gmail pro"
      },
      "fibre": {
        "title": "Fibre optique",
        "description": "Liens fibre dédiés et mutualisés pour votre entreprise"
      },
      "telephony": {
        "title": "Téléphonie",
        "description": "Trunk SIP, standard virtuel et lignes fixes pour les pros"
      }
    },
    "highlight": {
      "label": "Pack Business",
      "metric": "PRO",
      "caption": "Microsoft 365 + Fibre + SIP"
    },
    "note": {
      "text": "Licences, connectivité fibre et téléphonie réunies dans une offre sur mesure.",
      "detail": "Devis personnalisé sous 24 h"
    },
    "banner": {
      "title": "Un seul prestataire pour vos licences, votre fibre et vos lignes",
      "caption": "Offre sur mesure · devis personnalisé sous 24 h"
    }
  }
}
